import { render, staticRenderFns } from "./SeriesTitleTile.vue?vue&type=template&id=55a8382f&scoped=true&"
import script from "./SeriesTitleTile.vue?vue&type=script&lang=js&"
export * from "./SeriesTitleTile.vue?vue&type=script&lang=js&"
import style0 from "./SeriesTitleTile.vue?vue&type=style&index=0&id=55a8382f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8382f",
  null
  
)

component.options.__file = "SeriesTitleTile.vue"
export default component.exports